import { render, staticRenderFns } from "./ProcurementResolveRFMToPOsItemSelect.vue?vue&type=template&id=d40d5ff4&"
import script from "./ProcurementResolveRFMToPOsItemSelect.vue?vue&type=script&lang=js&"
export * from "./ProcurementResolveRFMToPOsItemSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports